import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const location = useLocation();
    const navigate = useNavigate();
    const { setUserFromCallback } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = location.hash || window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate("/login", { replace: true });
            return;
        }
        const sessionId = decodeURIComponent(match[1]);

        (async () => {
            try {
                const { data } = await api.post("/auth/google/session", { session_id: sessionId }, { withCredentials: true });
                // Persistir en el AuthProvider sin volver a llamar a /auth/me
                if (setUserFromCallback) setUserFromCallback(data.user);
                // Limpiar la fragment y aterrizar en el dashboard
                window.history.replaceState(null, "", "/dashboard");
                navigate("/dashboard", { replace: true, state: { user: data.user } });
            } catch (e) {
                console.error("Google auth error:", e);
                navigate("/login?error=google", { replace: true });
            }
        })();
    }, [location.hash, navigate, setUserFromCallback]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-white">
            <div className="text-center">
                <span className="elegant-loader"><span /><span /><span /></span>
                <p className="text-sm text-[var(--gf-text-secondary)] mt-4">Iniciando sesión con Google…</p>
            </div>
        </div>
    );
}
